import CryptoJS from 'crypto-js'

const EMBEDDED_DEEPSEEK_PLACEHOLDER = '__EMBEDDED_DEEPSEEK_KEY__'
const DEFAULT_SECRET = 'AltVerse|Testing|Deepseek'
const DEFAULT_PEPPER = 'AltVerse@2025'

const getEnv = (key, fallback = '') => {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env[key] ?? fallback
  }
  return fallback
}

const deriveSecret = () => {
  const baseSecret = getEnv('VITE_EMBEDDED_KEY_SECRET', DEFAULT_SECRET)
  const pepper = getEnv('VITE_EMBEDDED_KEY_PEPPER', DEFAULT_PEPPER)
  const host =
    typeof window !== 'undefined' && window.location
      ? window.location.hostname
      : 'localhost'

  return [baseSecret, pepper, host.length].join('#')
}

class EmbeddedKeyManager {
  constructor() {
    this.cache = {
      deepseek: null
    }
  }

  decrypt(cipherText) {
    if (!cipherText) return null
    try {
      const secret = deriveSecret()
      const bytes = CryptoJS.AES.decrypt(cipherText, secret)
      const decrypted = bytes.toString(CryptoJS.enc.Utf8)
      return decrypted || null
    } catch (error) {
      console.error('解密DeepSeek API Key失败:', error)
      return null
    }
  }

  getDeepseekKey() {
    if (this.cache.deepseek) return this.cache.deepseek
    const cipherText = getEnv('VITE_DEEPSEEK_API_KEY_ENC', '')
    const key = this.decrypt(cipherText)
    if (key) {
      this.cache.deepseek = key
    }
    return this.cache.deepseek
  }

  getPlaceholder() {
    return EMBEDDED_DEEPSEEK_PLACEHOLDER
  }

  isPlaceholder(value) {
    return value === EMBEDDED_DEEPSEEK_PLACEHOLDER
  }
}

const embeddedKeyManager = new EmbeddedKeyManager()

export default embeddedKeyManager
export { EMBEDDED_DEEPSEEK_PLACEHOLDER }

